/**
 * @generated SignedSource<<4da9f4ba541ad5ed7326f542f54762fc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SignalDetailContentMain_signal$data = {
  readonly body: string | null;
  readonly breadcrumbs: ReadonlyArray<string>;
  readonly descriptionFiles: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"SignalDetailFiles_files">;
  }>;
  readonly formattedBody: string | null;
  readonly id: string;
  readonly linkedProducts: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"LinkedProducts_products">;
  }>;
  readonly orgIconUri: string | null;
  readonly title: string;
  readonly updatedAtDate: {
    readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"SignalDetailImages_signal">;
  readonly " $fragmentType": "SignalDetailContentMain_signal";
};
export type SignalDetailContentMain_signal$key = {
  readonly " $data"?: SignalDetailContentMain_signal$data;
  readonly " $fragmentSpreads": FragmentRefs<"SignalDetailContentMain_signal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SignalDetailContentMain_signal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedBody",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "body",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orgIconUri",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "breadcrumbs",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "updatedAtDate",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StoreFormattedDate"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "descriptionFiles",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SignalDetailFiles_files"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreProduct",
      "kind": "LinkedField",
      "name": "linkedProducts",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LinkedProducts_products"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SignalDetailImages_signal"
    }
  ],
  "type": "Signal",
  "abstractKey": null
};

(node as any).hash = "70cdf8097f4554db2310333e87a82a6e";

export default node;
